import Vue from 'vue';

import {
  BIconFacebook,
  BIconTwitter,
  BIconYoutube,
  BIconInstagram,
  BIconTelephoneFill,
  BIconArrowReturnRight,
  BIconPencilSquare,
  BIconCalendarDateFill,
  BIconCalendarCheckFill,
  BIconChevronDoubleRight,
  BContainer,
  BRow,
  BCol,
  BCard,
  BButton,
  BCollapse,
  BJumbotron,
  BAlert,
  BNavbar,
  BNavbarBrand,
  BNavbarToggle,
  BNavbarNav,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormDatepicker,
  BFormTimepicker,
  BFormCheckbox,
  BFormRadio,
  BCarousel,
  BCarouselSlide
} from 'bootstrap-vue';

Vue.component('BIconFacebook', BIconFacebook);
Vue.component('BIconTwitter', BIconTwitter);
Vue.component('BIconYoutube', BIconYoutube);
Vue.component('BIconInstagram', BIconInstagram);
Vue.component('BIconTelephoneFill', BIconTelephoneFill);
Vue.component('BIconArrowReturnRight', BIconArrowReturnRight);
Vue.component('BIconPencilSquare', BIconPencilSquare);
Vue.component('BIconCalendarDateFill', BIconCalendarDateFill);
Vue.component('BIconCalendarCheckFill', BIconCalendarCheckFill);
Vue.component('BIconChevronDoubleRight', BIconChevronDoubleRight);
Vue.component('BContainer', BContainer);
Vue.component('BRow', BRow);
Vue.component('BCol', BCol);
Vue.component('BCard', BCard);
Vue.component('BButton', BButton);
Vue.component('BCollapse', BCollapse);
Vue.component('BJumbotron', BJumbotron);
Vue.component('BAlert', BAlert);
Vue.component('BNavbar', BNavbar);
Vue.component('BNavbarBrand', BNavbarBrand);
Vue.component('BNavbarToggle', BNavbarToggle);
Vue.component('BNavbarNav', BNavbarNav);
Vue.component('BForm', BForm);
Vue.component('BFormGroup', BFormGroup);
Vue.component('BFormInput', BFormInput);
Vue.component('BFormTextarea', BFormTextarea);
Vue.component('BFormDatepicker', BFormDatepicker);
Vue.component('BFormTimepicker', BFormTimepicker);
Vue.component('BFormCheckbox', BFormCheckbox);
Vue.component('BFormRadio', BFormRadio);
Vue.component('BCarousel', BCarousel);
Vue.component('BCarouselSlide', BCarouselSlide);
